// CT3F legal texts — FR / DE / EN

const COMPANY = {
  name: "Contrôle Technique des trois Frontières",
  short: "CT3F",
  email: "ctluxembourg@outlook.com",
  emailAlt: "info@ct3f.com",
  phoneLu: "+352 621 739 411",
  phoneBe: "+32 470 45 65 36",
  hours: "Lundi — Vendredi · 08:30 – 17:00",
  facebook: "Contrôle technique Fab",
  address: "27 avenue de la Liberté · L-4601 Differdange · Luxembourg",
  legalForm: "Entreprise individuelle",
  rcs: "A42911",
  tva: "LU 307 832 70",
  authorisation: "10096565",
  director: "RAINALDI Fabrizio",
  host: {
    name: "Infomaniak Network SA",
    address: "Rue Eugène-Marziano 25, 1227 Les Acacias – Genève, Suisse",
    contact: "infomaniak.com · support.infomaniak.com",
  },
};

export const legal = {
  fr: {
    mentions: {
      slug: "mentions-legales",
      label: "Mentions légales",
      eyebrow: "INFORMATIONS LÉGALES",
      title: "Mentions légales",
      updated: "Dernière mise à jour : décembre 2025",
      sections: [
        {
          h: "1. Éditeur du site",
          p: [
            `Le site **www.ct3f.com** est édité par **${COMPANY.name}** (« ${COMPANY.short} »), entreprise individuelle exerçant une activité de passage au contrôle technique, de prestations à l'immatriculation et de procédures import/export entre le Luxembourg, la France et la Belgique.`,
            `Forme juridique : ${COMPANY.legalForm}`,
            `Adresse : ${COMPANY.address}`,
            `Inscription RCS Luxembourg : ${COMPANY.rcs}`,
            `N° TVA intracommunautaire : ${COMPANY.tva}`,
            `Autorisation d'établissement : ${COMPANY.authorisation}`,
            `Responsable / Directeur de la publication : ${COMPANY.director}`,
            `Téléphone : ${COMPANY.phoneLu} (LU) · ${COMPANY.phoneBe} (BE) · E-mails : ${COMPANY.email} · ${COMPANY.emailAlt}`,
          ],
        },
        {
          h: "2. Hébergement",
          p: [
            `Le site est hébergé par ${COMPANY.host.name}, ${COMPANY.host.address}. Contact : ${COMPANY.host.contact}.`,
          ],
        },
        {
          h: "3. Activité réglementée",
          p: [
            "CT3F intervient en qualité de prestataire de services administratifs et techniques dans le domaine automobile. Les contrôles techniques officiels sont réalisés exclusivement par les organismes agréés des pays concernés (SNCT au Luxembourg, organismes agréés UTAC/OPC en France, GOCA en Belgique). CT3F n'est pas un organisme de contrôle agréé : son rôle consiste à préparer, présenter et accompagner le véhicule jusqu'à ces organismes, et à constituer les dossiers d'immatriculation auprès des autorités compétentes (SNCA, ANTS, DIV).",
          ],
        },
        {
          h: "4. Propriété intellectuelle",
          p: [
            "L'ensemble du contenu présent sur le site (textes, images, charte graphique, logo, code) est la propriété exclusive de CT3F ou de ses partenaires et est protégé par les lois luxembourgeoises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.",
          ],
        },
        {
          h: "5. Limitation de responsabilité",
          p: [
            "CT3F s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, CT3F ne peut garantir l'absence d'erreurs ou d'omissions et décline toute responsabilité quant à l'utilisation faite de ces informations. Les délais et procédures dépendent des autorités compétentes des trois pays et peuvent varier.",
          ],
        },
        {
          h: "6. Liens externes",
          p: [
            "Le site peut contenir des liens vers des sites tiers. CT3F n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
          ],
        },
        {
          h: "7. Droit applicable",
          p: [
            "Les présentes mentions sont régies par le droit luxembourgeois. Tout litige relève de la compétence exclusive des tribunaux de Luxembourg-Ville.",
          ],
        },
      ],
    },
    privacy: {
      slug: "confidentialite",
      label: "Politique de confidentialité",
      eyebrow: "DONNÉES PERSONNELLES",
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : décembre 2025",
      sections: [
        {
          h: "1. Responsable du traitement",
          p: [
            `Le responsable du traitement des données collectées via le site www.ct3f.com est ${COMPANY.name}, joignable à l'adresse ${COMPANY.email}.`,
          ],
        },
        {
          h: "2. Données collectées",
          p: [
            "Lorsque vous remplissez le formulaire de contact, nous collectons les données suivantes : nom et prénom, adresse e-mail, numéro de téléphone (facultatif), service concerné, objet et contenu du message, langue d'utilisation du site.",
            "Nous ne collectons aucune donnée bancaire via ce site. Les détails techniques de votre véhicule (marque, modèle, immatriculation) ne sont collectés que si vous nous les communiquez volontairement dans votre message.",
          ],
        },
        {
          h: "3. Finalités et bases légales",
          p: [
            "Les données sont traitées pour répondre à votre demande, établir un devis, planifier la prestation et assurer le suivi du dossier. La base légale est l'exécution de mesures précontractuelles prises à votre demande (article 6.1.b RGPD) et notre intérêt légitime à gérer la relation client (article 6.1.f RGPD).",
          ],
        },
        {
          h: "4. Durée de conservation",
          p: [
            "Les demandes de contact non suivies d'effet sont conservées pendant 12 mois. Les données liées à un dossier client effectivement traité sont conservées pendant la durée nécessaire à la prestation puis archivées 10 ans conformément aux obligations comptables et fiscales luxembourgeoises.",
          ],
        },
        {
          h: "5. Destinataires",
          p: [
            "Les données sont destinées exclusivement aux services internes de CT3F en charge du traitement de votre demande. Elles peuvent être transmises aux autorités compétentes (SNCT, SNCA, ANTS, DIV, douanes) lorsque la prestation l'exige, ainsi qu'à nos partenaires techniques agréés. Aucune donnée n'est cédée à des tiers à des fins commerciales.",
          ],
        },
        {
          h: "6. Transferts hors UE",
          p: [
            "Les données sont hébergées au sein de l'Union européenne. Aucun transfert hors UE n'est effectué.",
          ],
        },
        {
          h: "7. Vos droits (RGPD)",
          p: [
            "Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi luxembourgeoise du 1er août 2018, vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Vous pouvez exercer ces droits par e-mail à ctluxembourg@outlook.com en justifiant de votre identité.",
            "Vous avez également le droit d'introduire une réclamation auprès de la CNPD (Commission Nationale pour la Protection des Données — Luxembourg, www.cnpd.lu).",
          ],
        },
        {
          h: "8. Cookies",
          p: [
            "Le site www.ct3f.com n'utilise pas de cookies de tracking publicitaire ni d'outils de mesure d'audience tiers. Seul un stockage local technique (localStorage) est utilisé pour mémoriser la langue choisie par l'utilisateur. Aucun consentement préalable n'est requis pour cette finalité strictement nécessaire.",
          ],
        },
        {
          h: "9. Sécurité",
          p: [
            "CT3F met en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données contre toute perte, altération ou accès non autorisé.",
          ],
        },
      ],
    },
    terms: {
      slug: "cgv",
      label: "Conditions générales",
      eyebrow: "CONDITIONS GÉNÉRALES DE PRESTATION",
      title: "Conditions générales",
      updated: "Dernière mise à jour : juin 2026",
      sections: [
        {
          h: "1. Objet",
          p: [
            `Les présentes Conditions Générales (« CG ») régissent les prestations fournies par ${COMPANY.name} (« CT3F ») à toute personne physique ou morale (« le Client ») sollicitant un service de passage au contrôle technique, d'immatriculation, ou de procédure import/export entre le Luxembourg, la France et la Belgique.`,
          ],
        },
        {
          h: "2. Devis et commande",
          p: [
            "Toute prestation fait l'objet d'un devis préalable transmis par e-mail. Le devis précise la nature de la prestation, le tarif, les délais indicatifs et les pièces nécessaires. La commande est ferme à compter de l'acceptation écrite du devis par le Client (signature ou retour e-mail explicite).",
          ],
        },
        {
          h: "3. Obligations du Client",
          p: [
            "Le Client s'engage à fournir tous les documents et informations nécessaires (carte grise, certificat de conformité, justificatifs d'identité et de domicile, quitus fiscal le cas échéant) ainsi qu'à présenter le véhicule dans un état permettant le contrôle. Le Client garantit l'exactitude des informations transmises.",
          ],
        },
        {
          h: "4. Obligations de CT3F",
          p: [
            "CT3F est tenue à une obligation de moyens et s'engage à exécuter la prestation avec diligence et conformément aux règles de l'art. CT3F ne saurait être tenue pour responsable du résultat du contrôle technique lui-même, qui relève de la décision exclusive de l'organisme agréé compétent (SNCT, UTAC/OPC, GOCA).",
          ],
        },
        {
          h: "5. Tarifs et paiement",
          p: [
            "Les tarifs sont exprimés en euros, taxes comprises lorsque applicable. Sauf accord particulier, le paiement intervient à l'achèvement de la prestation, par virement bancaire ou tout moyen accepté par CT3F. Tout retard de paiement entraîne, après mise en demeure restée infructueuse, l'application d'intérêts au taux légal luxembourgeois en vigueur.",
          ],
        },
        {
          h: "6. TVA, taxes et frais d'immatriculation",
          p: [
            "Le Client acquéreur résidant hors du Luxembourg reconnaît avoir été expressément informé que, lorsque le véhicule est vendu hors taxes (HTVA) et qu'il est considéré comme neuf au sens de la réglementation fiscale européenne (moins de 6 mois depuis sa première mise en circulation ou moins de 6 000 km), le règlement de la TVA sera exigé dans son pays de résidence.",
            "Pour la France, le Client déclare avoir pris connaissance de l'ensemble des taxes fiscales et écologiques exigibles dans son pays de résidence (notamment le malus écologique, le cas échéant). Toutes les taxes qui en découlent demeurent intégralement à sa charge et constituent le prix final de la carte grise.",
            "CT3F est mandatée par le Client et, le cas échéant, par le garage vendeur pour effectuer les démarches administratives relatives à l'immatriculation du véhicule. Toutefois, CT3F décline toute responsabilité quant au montant, au calcul, aux éventuelles modifications ou à l'exigibilité des taxes et droits réclamés par les administrations compétentes. Ces sommes restent exclusivement à la charge du Client et ne sont en aucun cas avancées ni financées par CT3F.",
          ],
        },
        {
          h: "7. Délais",
          p: [
            "Les délais communiqués sont indicatifs et dépendent notamment de la disponibilité des organismes de contrôle et des autorités d'immatriculation des trois pays concernés. Aucun retard imputable à ces tiers ne pourra engager la responsabilité de CT3F.",
          ],
        },
        {
          h: "8. Annulation",
          p: [
            "En cas d'annulation par le Client après acceptation du devis, les frais déjà engagés par CT3F (rendez-vous réservés, frais administratifs, traductions) restent dus.",
          ],
        },
        {
          h: "9. Responsabilité",
          p: [
            "La responsabilité de CT3F est limitée au montant de la prestation facturée. CT3F ne saurait être tenue responsable des dommages indirects (perte d'exploitation, perte de chance, préjudice commercial). Aucun élément des présentes CG ne limite la responsabilité légale de CT3F en cas de faute lourde ou intentionnelle.",
          ],
        },
        {
          h: "10. Force majeure",
          p: [
            "CT3F ne peut être tenue responsable d'un manquement résultant d'un cas de force majeure au sens de la jurisprudence luxembourgeoise (grève, fermeture administrative, événement climatique, indisponibilité des organismes officiels, etc.).",
          ],
        },
        {
          h: "11. Données personnelles",
          p: [
            "Le traitement des données personnelles est régi par notre Politique de confidentialité, accessible depuis le pied de page du site.",
          ],
        },
        {
          h: "12. Droit applicable et juridiction",
          p: [
            "Les présentes CG sont soumises au droit luxembourgeois. Tout litige relève de la compétence exclusive des tribunaux de Luxembourg-Ville, sauf disposition impérative contraire.",
          ],
        },
      ],
    },
  },

  de: {
    mentions: {
      slug: "impressum",
      label: "Impressum",
      eyebrow: "RECHTLICHE ANGABEN",
      title: "Impressum",
      updated: "Letzte Aktualisierung: Dezember 2025",
      sections: [
        {
          h: "1. Herausgeber",
          p: [
            `Die Website **www.ct3f.com** wird herausgegeben von **${COMPANY.name}** („${COMPANY.short}"), einzelunternehmerisch geführt mit Tätigkeit im Bereich technische Fahrzeugprüfung, Zulassungsleistungen sowie Import-/Exportverfahren zwischen Luxemburg, Frankreich und Belgien.`,
            `Rechtsform: ${COMPANY.legalForm}`,
            `Anschrift: ${COMPANY.address}`,
            `Handelsregister Luxemburg: ${COMPANY.rcs}`,
            `USt-IdNr.: ${COMPANY.tva}`,
            `Niederlassungsgenehmigung: ${COMPANY.authorisation}`,
            `Verantwortlich für den Inhalt: ${COMPANY.director}`,
            `Telefon: ${COMPANY.phoneLu} (LU) · ${COMPANY.phoneBe} (BE) · E-Mails: ${COMPANY.email} · ${COMPANY.emailAlt}`,
          ],
        },
        {
          h: "2. Hosting",
          p: [
            `Die Website wird gehostet von ${COMPANY.host.name}, ${COMPANY.host.address}. Kontakt: ${COMPANY.host.contact}.`,
          ],
        },
        {
          h: "3. Regulierte Tätigkeit",
          p: [
            "CT3F handelt als Dienstleister für administrative und technische Fahrzeugverfahren. Die offiziellen technischen Prüfungen werden ausschließlich von den anerkannten Stellen der jeweiligen Länder durchgeführt (SNCT in Luxemburg, UTAC/OPC in Frankreich, GOCA in Belgien). CT3F ist keine anerkannte Prüfstelle.",
          ],
        },
        {
          h: "4. Urheberrecht",
          p: [
            "Sämtliche Inhalte dieser Website (Texte, Bilder, Layout, Logo, Quellcode) sind ausschließliches Eigentum von CT3F und sind durch luxemburgisches und internationales Urheberrecht geschützt. Jede vollständige oder teilweise Vervielfältigung ohne vorherige schriftliche Zustimmung ist untersagt.",
          ],
        },
        {
          h: "5. Haftungsbeschränkung",
          p: [
            "CT3F bemüht sich um die Richtigkeit und Aktualität der bereitgestellten Informationen. Eine Haftung für Fehler oder Auslassungen wird jedoch ausgeschlossen. Fristen und Verfahren hängen von den Behörden der drei Länder ab und können variieren.",
          ],
        },
        {
          h: "6. Externe Links",
          p: [
            "Die Website kann Links zu Drittseiten enthalten. CT3F übernimmt keinerlei Verantwortung für deren Inhalt.",
          ],
        },
        {
          h: "7. Anwendbares Recht",
          p: [
            "Es gilt luxemburgisches Recht. Ausschließlicher Gerichtsstand ist Luxemburg-Stadt.",
          ],
        },
      ],
    },
    privacy: {
      slug: "datenschutz",
      label: "Datenschutz",
      eyebrow: "PERSONENBEZOGENE DATEN",
      title: "Datenschutzerklärung",
      updated: "Letzte Aktualisierung: Dezember 2025",
      sections: [
        {
          h: "1. Verantwortliche Stelle",
          p: [
            `Verantwortlich für die Datenverarbeitung über www.ct3f.com ist ${COMPANY.name}, erreichbar unter ${COMPANY.email}.`,
          ],
        },
        {
          h: "2. Erhobene Daten",
          p: [
            "Beim Ausfüllen des Kontaktformulars erheben wir: Name, E-Mail-Adresse, Telefonnummer (optional), gewünschte Leistung, Betreff und Inhalt der Nachricht sowie die gewählte Sprache.",
            "Über diese Website werden keine Zahlungsdaten erhoben.",
          ],
        },
        {
          h: "3. Zwecke und Rechtsgrundlagen",
          p: [
            "Die Daten werden zur Bearbeitung Ihrer Anfrage, zur Angebotserstellung und zur Auftragsabwicklung verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie lit. f (berechtigtes Interesse).",
          ],
        },
        {
          h: "4. Speicherdauer",
          p: [
            "Anfragen ohne Folgegeschäft werden 12 Monate gespeichert. Daten zu abgeschlossenen Aufträgen werden gemäß luxemburgischem Handels- und Steuerrecht 10 Jahre archiviert.",
          ],
        },
        {
          h: "5. Empfänger",
          p: [
            "Die Daten werden ausschließlich von CT3F-Mitarbeitenden bearbeitet und ggf. an die zuständigen Behörden (SNCT, SNCA, ANTS, DIV, Zoll) sowie zugelassene Partner übermittelt. Eine Weitergabe zu Werbezwecken erfolgt nicht.",
          ],
        },
        {
          h: "6. Drittlandtransfer",
          p: [
            "Die Daten werden innerhalb der Europäischen Union gehostet. Es findet keine Übermittlung in Drittländer statt.",
          ],
        },
        {
          h: "7. Ihre Rechte (DSGVO)",
          p: [
            "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch und Datenübertragbarkeit. Anfragen richten Sie an ctluxembourg@outlook.com.",
            "Außerdem haben Sie das Recht, sich bei der CNPD (Nationale Datenschutzkommission Luxemburg, www.cnpd.lu) zu beschweren.",
          ],
        },
        {
          h: "8. Cookies",
          p: [
            "Diese Website verwendet keine Tracking- oder Werbe-Cookies. Lediglich der lokale Speicher (localStorage) wird genutzt, um die gewählte Sprache zu speichern — eine Einwilligung ist hierfür nicht erforderlich.",
          ],
        },
        {
          h: "9. Sicherheit",
          p: [
            "CT3F trifft angemessene technische und organisatorische Maßnahmen zum Schutz Ihrer Daten.",
          ],
        },
      ],
    },
    terms: {
      slug: "agb",
      label: "AGB",
      eyebrow: "ALLGEMEINE GESCHÄFTSBEDINGUNGEN",
      title: "Allgemeine Geschäftsbedingungen",
      updated: "Letzte Aktualisierung: Juni 2026",
      sections: [
        {
          h: "1. Gegenstand",
          p: [
            `Die vorliegenden AGB regeln die von ${COMPANY.name} („CT3F") für jede natürliche oder juristische Person („Kunde") erbrachten Leistungen im Bereich technische Fahrzeugprüfung, Zulassung sowie Import/Export zwischen Luxemburg, Frankreich und Belgien.`,
          ],
        },
        {
          h: "2. Angebot und Auftrag",
          p: [
            "Jede Leistung beruht auf einem vorab per E-Mail übermittelten Angebot. Der Auftrag ist mit der schriftlichen Annahme des Angebots durch den Kunden verbindlich.",
          ],
        },
        {
          h: "3. Pflichten des Kunden",
          p: [
            "Der Kunde verpflichtet sich, alle erforderlichen Unterlagen bereitzustellen (Fahrzeugschein, Konformitätsbescheinigung, Identitäts- und Wohnsitznachweise, ggf. Steuerquittung) und das Fahrzeug in prüfbarem Zustand vorzuführen.",
          ],
        },
        {
          h: "4. Pflichten von CT3F",
          p: [
            "CT3F schuldet eine Bemühenspflicht und führt die Leistung sorgfältig und fachgerecht aus. Das Ergebnis der eigentlichen technischen Prüfung obliegt ausschließlich der zuständigen Prüfstelle (SNCT, UTAC/OPC, GOCA).",
          ],
        },
        {
          h: "5. Preise und Zahlung",
          p: [
            "Die Preise verstehen sich in Euro, ggf. inkl. Steuern. Die Zahlung erfolgt nach Abschluss der Leistung per Banküberweisung oder anderem von CT3F akzeptiertem Zahlungsmittel. Bei Zahlungsverzug fallen nach Mahnung gesetzliche luxemburgische Verzugszinsen an.",
          ],
        },
        {
          h: "6. Mehrwertsteuer, Steuern und Zulassungskosten",
          p: [
            "Der außerhalb Luxemburgs ansässige Kunde bestätigt, ausdrücklich darüber informiert worden zu sein, dass bei einem ohne Mehrwertsteuer (netto) verkauften Fahrzeug, das im Sinne der europäischen Steuervorschriften als neu gilt (weniger als 6 Monate seit Erstzulassung oder weniger als 6 000 km), die Mehrwertsteuer in seinem Wohnsitzland zu entrichten ist.",
            "Für Frankreich erklärt der Kunde, sämtliche in seinem Wohnsitzland fälligen steuerlichen und ökologischen Abgaben (insbesondere ggf. das Öko-Malus) zur Kenntnis genommen zu haben. Alle daraus resultierenden Steuern gehen vollständig zu seinen Lasten und bilden den Endpreis der Zulassungsbescheinigung (Carte grise).",
            "CT3F wird vom Kunden und ggf. vom verkaufenden Garagenbetrieb mit den administrativen Schritten zur Fahrzeugzulassung beauftragt. CT3F übernimmt jedoch keinerlei Haftung für Höhe, Berechnung, etwaige Änderungen oder Fälligkeit der von den zuständigen Behörden erhobenen Steuern und Abgaben. Diese Beträge gehen ausschließlich zu Lasten des Kunden und werden von CT3F weder vorgestreckt noch finanziert.",
          ],
        },
        {
          h: "7. Fristen",
          p: [
            "Mitgeteilte Fristen sind unverbindlich und hängen von den Prüfstellen und Behörden der drei Länder ab. Verzögerungen, die diesen Dritten zuzurechnen sind, begründen keine Haftung von CT3F.",
          ],
        },
        {
          h: "8. Stornierung",
          p: [
            "Bei Stornierung nach Auftragsannahme bleiben bereits angefallene Kosten geschuldet (Termine, Verwaltungsgebühren, Übersetzungen).",
          ],
        },
        {
          h: "9. Haftung",
          p: [
            "Die Haftung von CT3F ist auf den Rechnungsbetrag der Leistung begrenzt. Eine Haftung für mittelbare Schäden (entgangener Gewinn, Geschäftsausfall) ist ausgeschlossen, ausgenommen bei Vorsatz oder grober Fahrlässigkeit.",
          ],
        },
        {
          h: "10. Höhere Gewalt",
          p: [
            "CT3F haftet nicht für Pflichtverletzungen aufgrund höherer Gewalt im Sinne der luxemburgischen Rechtsprechung (Streik, behördliche Schließung, Wetterereignisse, Nichtverfügbarkeit offizieller Stellen u. a.).",
          ],
        },
        {
          h: "11. Personenbezogene Daten",
          p: [
            "Die Verarbeitung personenbezogener Daten ist in unserer Datenschutzerklärung geregelt.",
          ],
        },
        {
          h: "12. Anwendbares Recht und Gerichtsstand",
          p: [
            "Es gilt luxemburgisches Recht. Ausschließlicher Gerichtsstand ist Luxemburg-Stadt, soweit nicht zwingende Vorschriften entgegenstehen.",
          ],
        },
      ],
    },
  },

  en: {
    mentions: {
      slug: "legal-notice",
      label: "Legal notice",
      eyebrow: "LEGAL INFORMATION",
      title: "Legal notice",
      updated: "Last update: December 2025",
      sections: [
        {
          h: "1. Site publisher",
          p: [
            `The website **www.ct3f.com** is published by **${COMPANY.name}** ("${COMPANY.short}"), a sole proprietorship providing technical inspection, vehicle registration and import/export services across Luxembourg, France and Belgium.`,
            `Legal form: ${COMPANY.legalForm}`,
            `Address: ${COMPANY.address}`,
            `Luxembourg trade register: ${COMPANY.rcs}`,
            `EU VAT ID: ${COMPANY.tva}`,
            `Business authorisation: ${COMPANY.authorisation}`,
            `Publication director: ${COMPANY.director}`,
            `Phone: ${COMPANY.phoneLu} (LU) · ${COMPANY.phoneBe} (BE) · Emails: ${COMPANY.email} · ${COMPANY.emailAlt}`,
          ],
        },
        {
          h: "2. Hosting",
          p: [
            `The website is hosted by ${COMPANY.host.name}, ${COMPANY.host.address}. Contact: ${COMPANY.host.contact}.`,
          ],
        },
        {
          h: "3. Regulated activity",
          p: [
            "CT3F acts as a service provider handling administrative and technical formalities for motor vehicles. Official technical inspections are carried out exclusively by the approved bodies of each country (SNCT in Luxembourg, UTAC/OPC accredited centres in France, GOCA in Belgium). CT3F is not an approved inspection body itself.",
          ],
        },
        {
          h: "4. Intellectual property",
          p: [
            "All content on this website (text, images, design, logo, code) is the exclusive property of CT3F or its partners and is protected by Luxembourgish and international intellectual-property law. Any reproduction, representation or modification, whether total or partial, without prior written consent is prohibited.",
          ],
        },
        {
          h: "5. Limitation of liability",
          p: [
            "CT3F endeavours to keep the information published on the site accurate and up-to-date. CT3F cannot however guarantee the absence of errors or omissions and disclaims all liability for the use of such information. Lead times and procedures depend on the competent authorities of the three countries and may vary.",
          ],
        },
        {
          h: "6. External links",
          p: [
            "The site may contain links to third-party websites. CT3F has no control over those sites and disclaims any liability for their content.",
          ],
        },
        {
          h: "7. Governing law",
          p: [
            "These notices are governed by Luxembourg law. Any dispute shall fall under the exclusive jurisdiction of the courts of Luxembourg-City.",
          ],
        },
      ],
    },
    privacy: {
      slug: "privacy",
      label: "Privacy policy",
      eyebrow: "PERSONAL DATA",
      title: "Privacy policy",
      updated: "Last update: December 2025",
      sections: [
        {
          h: "1. Data controller",
          p: [
            `The controller of data collected through www.ct3f.com is ${COMPANY.name}, reachable at ${COMPANY.email}.`,
          ],
        },
        {
          h: "2. Data collected",
          p: [
            "When you submit the contact form we collect: name, email address, phone number (optional), service requested, subject and content of the message, and language used.",
            "No payment data is collected via this site.",
          ],
        },
        {
          h: "3. Purposes and legal bases",
          p: [
            "Data is processed in order to handle your request, prepare a quote, schedule the service and follow up on the file. The legal basis is performance of pre-contractual measures (Art. 6.1.b GDPR) and our legitimate interest in managing the customer relationship (Art. 6.1.f GDPR).",
          ],
        },
        {
          h: "4. Retention",
          p: [
            "Contact requests without follow-up are kept for 12 months. Data linked to an actual customer file is kept for the duration of the service then archived for 10 years in line with Luxembourg accounting and tax obligations.",
          ],
        },
        {
          h: "5. Recipients",
          p: [
            "Data is accessed solely by CT3F staff handling your request and may be transmitted to competent authorities (SNCT, SNCA, ANTS, DIV, customs) and approved technical partners as required. No data is sold or transferred for marketing purposes.",
          ],
        },
        {
          h: "6. Transfers outside the EU",
          p: [
            "Data is hosted within the European Union. No transfer outside the EU is performed.",
          ],
        },
        {
          h: "7. Your rights (GDPR)",
          p: [
            "Under Regulation (EU) 2016/679 (GDPR) and the Luxembourg Act of 1 August 2018, you have the right to access, rectify, erase, restrict processing of, object to and port your data. You may exercise these rights by emailing ctluxembourg@outlook.com with proof of identity.",
            "You also have the right to lodge a complaint with the CNPD (Luxembourg National Data Protection Commission, www.cnpd.lu).",
          ],
        },
        {
          h: "8. Cookies",
          p: [
            "www.ct3f.com does not use advertising or third-party analytics cookies. Only a strictly necessary local storage entry (localStorage) is used to remember the chosen language. No prior consent is required for this purpose.",
          ],
        },
        {
          h: "9. Security",
          p: [
            "CT3F implements appropriate technical and organisational measures to protect your data against loss, alteration or unauthorised access.",
          ],
        },
      ],
    },
    terms: {
      slug: "terms",
      label: "Terms of use",
      eyebrow: "GENERAL TERMS OF SERVICE",
      title: "Terms of service",
      updated: "Last update: June 2026",
      sections: [
        {
          h: "1. Object",
          p: [
            `These General Terms ("GT") govern the services provided by ${COMPANY.name} ("CT3F") to any individual or legal entity ("Client") requesting technical-inspection, registration or import/export services between Luxembourg, France and Belgium.`,
          ],
        },
        {
          h: "2. Quote and order",
          p: [
            "Every service is preceded by a written quote sent by email, specifying scope, price, indicative lead time and required documents. The order becomes firm upon written acceptance of the quote by the Client.",
          ],
        },
        {
          h: "3. Client's obligations",
          p: [
            "The Client undertakes to provide all required documents (registration certificate, certificate of conformity, ID and address proof, fiscal clearance where applicable) and to present the vehicle in inspectable condition. The Client warrants the accuracy of the information supplied.",
          ],
        },
        {
          h: "4. CT3F's obligations",
          p: [
            "CT3F is bound by an obligation of means and undertakes to perform the service diligently and to industry standards. CT3F cannot be held liable for the outcome of the technical inspection itself, which is decided exclusively by the competent approved body (SNCT, UTAC/OPC, GOCA).",
          ],
        },
        {
          h: "5. Pricing and payment",
          p: [
            "Prices are in euros, including taxes where applicable. Unless otherwise agreed, payment is due upon completion of the service, by bank transfer or any other means accepted by CT3F. Late payment shall, after formal notice, accrue interest at the legal Luxembourg rate then in force.",
          ],
        },
        {
          h: "6. VAT, taxes and registration fees",
          p: [
            "A purchasing Client residing outside Luxembourg acknowledges having been expressly informed that, where a vehicle is sold exclusive of VAT and qualifies as new within the meaning of European tax regulations (less than 6 months since its first registration or less than 6,000 km), VAT will be payable in the Client's country of residence.",
            "For France, the Client acknowledges having taken note of all fiscal and ecological taxes due in their country of residence (including the ecological malus, where applicable). All resulting taxes remain entirely at the Client's expense and constitute the final price of the registration certificate (carte grise).",
            "CT3F is mandated by the Client and, where applicable, by the selling garage to carry out the administrative formalities relating to the vehicle's registration. However, CT3F declines all liability as to the amount, calculation, any changes or the enforceability of the taxes and duties claimed by the competent authorities. Such amounts remain exclusively payable by the Client and are under no circumstances advanced or financed by CT3F.",
          ],
        },
        {
          h: "7. Lead times",
          p: [
            "Lead times communicated are indicative and depend in particular on the availability of the inspection bodies and registration authorities of the three countries. No delay attributable to those third parties may engage CT3F's liability.",
          ],
        },
        {
          h: "8. Cancellation",
          p: [
            "If the Client cancels after acceptance of the quote, costs already incurred by CT3F (booked appointments, administrative fees, translations) shall remain due.",
          ],
        },
        {
          h: "9. Liability",
          p: [
            "CT3F's liability is capped at the amount of the invoiced service. CT3F shall not be liable for indirect damages (loss of profit, business interruption, commercial loss). Nothing herein limits CT3F's statutory liability for gross negligence or wilful misconduct.",
          ],
        },
        {
          h: "10. Force majeure",
          p: [
            "CT3F cannot be held liable for any failure resulting from force majeure as construed under Luxembourg case law (strike, administrative closure, weather event, unavailability of official bodies, etc.).",
          ],
        },
        {
          h: "11. Personal data",
          p: [
            "The processing of personal data is governed by our Privacy Policy, accessible from the site footer.",
          ],
        },
        {
          h: "12. Governing law and jurisdiction",
          p: [
            "These GT are governed by Luxembourg law. Any dispute shall fall under the exclusive jurisdiction of the courts of Luxembourg-City, save for mandatory provisions to the contrary.",
          ],
        },
      ],
    },
  },
};

export const legalPagesByLang = (lang) => legal[lang] || legal.fr;
